export const MIGRATION_STATUS = {
  PENDING: 'P',
  COMPLETE: 'C',
};
